const initialState = {
  email: '',
  submitted: false,
  isLoading: false
};

export default function newsletterReducer(state = initialState, action) {
  switch (action.type) {
    case 'CHANGE_NEWSLETTER_EMAIL': {
      const { name, value } = action.payload;
      return { ...state, [name]: value };
    }

    case 'SUBMIT_NEWSLETTER_FORM_START': {
      return { ...state, isLoading: true };
    }

    case 'SUBMIT_NEWSLETTER_FORM_SUCCESS': {
      return { ...state, isLoading: false, submitted: true, email: '' };
    }

    case 'SUBMIT_NEWSLETTER_FORM_ERROR': {
      return { ...state, isLoading: false };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/newsletter_form/reducer.js